var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bg-white q-pa-md full-height" },
    [
      _c("customer-select", {
        directives: [
          {
            name: "validate",
            rawName: "v-validate.disable",
            value: "required",
            expression: "'required'",
            modifiers: { disable: true }
          }
        ],
        attrs: {
          name: "customer",
          hasError: _vm.errors.has("customer"),
          errorLabel: _vm.errors.first("customer"),
          "data-vv-as": _vm.$tc("customer", 1)
        },
        on: { input: _vm.updateDueDate },
        model: {
          value: _vm.local.customer,
          callback: function($$v) {
            _vm.$set(_vm.local, "customer", $$v)
          },
          expression: "local.customer"
        }
      }),
      _vm.local.customer
        ? _c("customer-address-select", {
            staticClass: "q-mt-md",
            attrs: { customer: _vm.local.customer },
            on: { reFetchCustomer: _vm.handleReFetchCustomer },
            model: {
              value: _vm.local.invoiceAddresses,
              callback: function($$v) {
                _vm.$set(_vm.local, "invoiceAddresses", $$v)
              },
              expression: "local.invoiceAddresses"
            }
          })
        : _vm._e(),
      _c(
        "div",
        { staticClass: "row" },
        [
          _c(
            "q-field",
            {
              staticClass: "col",
              attrs: {
                error: _vm.errors.has("invoiceTitle"),
                "error-label": _vm.errors.first("invoiceTitle")
              }
            },
            [
              _c("q-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate.disable",
                    value: "required",
                    expression: "'required'",
                    modifiers: { disable: true }
                  }
                ],
                attrs: {
                  name: "invoiceTitle",
                  value: _vm.local.invoiceTitle,
                  "float-label": _vm.$t("invoice_title"),
                  "data-vv-as": _vm.$t("invoice_title")
                },
                on: {
                  input: function(val) {
                    return _vm.update("invoiceTitle", val)
                  }
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "row gutter-sm" },
        [
          _c(
            "q-field",
            {
              staticClass: "col",
              attrs: {
                error: _vm.errors.has("invoiceDate"),
                "error-label": _vm.errors.first("invoiceDate")
              }
            },
            [
              _c("q-datetime", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate.disable",
                    value: "required",
                    expression: "'required'",
                    modifiers: { disable: true }
                  }
                ],
                attrs: {
                  name: "invoiceDate",
                  value: _vm.local.invoiceDate,
                  type: "date",
                  "float-label": _vm.$t("invoice_date"),
                  "data-vv-as": _vm.$t("invoice_date"),
                  format: _vm.$t("date_format"),
                  clearable: ""
                },
                on: {
                  input: function(val) {
                    return _vm.update("invoiceDate", val)
                  }
                }
              })
            ],
            1
          ),
          _c(
            "q-field",
            {
              staticClass: "col",
              attrs: {
                error: _vm.errors.has("deliveryDate"),
                "error-label": _vm.errors.first("deliveryDate")
              }
            },
            [
              _c("q-datetime", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate.disable",
                    value: "required",
                    expression: "'required'",
                    modifiers: { disable: true }
                  }
                ],
                attrs: {
                  name: "deliveryDate",
                  value: _vm.local.deliveryDate,
                  type: "date",
                  "float-label": _vm.$t("delivery_date"),
                  "data-vv-as": _vm.$t("delivery_date"),
                  format: _vm.$t("date_format"),
                  clearable: ""
                },
                on: {
                  input: function(val) {
                    return _vm.update("deliveryDate", val)
                  }
                }
              })
            ],
            1
          ),
          _c(
            "q-field",
            {
              staticClass: "col",
              attrs: {
                error: _vm.errors.has("dueDate"),
                "error-label": _vm.errors.first("dueDate")
              }
            },
            [
              _c("q-datetime", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate.disable",
                    value: "",
                    expression: "''",
                    modifiers: { disable: true }
                  }
                ],
                attrs: {
                  name: "dueDate",
                  value: _vm.local.dueDate,
                  type: "date",
                  "float-label": _vm.$t("due_date"),
                  "data-vv-as": _vm.$t("due_date"),
                  format: _vm.$t("date_format"),
                  clearable: ""
                },
                on: {
                  input: function(val) {
                    return _vm.update("dueDate", val)
                  }
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "row" },
        [
          _c(
            "q-field",
            {
              staticClass: "col-6",
              attrs: {
                error: _vm.errors.has("invoiceNumber"),
                "error-label": _vm.errors.first("invoiceNumber")
              }
            },
            [
              _c("q-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate.disable",
                    value: "required",
                    expression: "'required'",
                    modifiers: { disable: true }
                  }
                ],
                attrs: {
                  name: "invoiceNumber",
                  value: _vm.local.invoiceNumber,
                  "float-label": _vm.$t("invoice_number"),
                  "data-vv-as": _vm.$t("invoice_number")
                },
                on: {
                  input: function(val) {
                    return _vm.update("invoiceNumber", val)
                  }
                }
              })
            ],
            1
          ),
          _c(
            "q-field",
            {
              staticClass: "col-3",
              attrs: {
                error: _vm.errors.has("status"),
                "error-label": _vm.errors.first("status")
              }
            },
            [
              _c("q-select", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate.disable",
                    value: "required",
                    expression: "'required'",
                    modifiers: { disable: true }
                  }
                ],
                attrs: {
                  name: "status",
                  value: _vm.local.status,
                  options: _vm.possibleStatus,
                  "float-label": _vm.$t("invoice_status"),
                  "data-vv-as": _vm.$t("invoice_status")
                },
                on: {
                  input: function(val) {
                    return _vm.update("status", val)
                  }
                }
              })
            ],
            1
          ),
          _vm.local.status === "paid"
            ? _c(
                "q-field",
                {
                  staticClass: "col-3",
                  attrs: {
                    error: _vm.errors.has("paidAt"),
                    "error-label": _vm.errors.first("paidAt")
                  }
                },
                [
                  _c("q-datetime", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate.disable",
                        value: "required",
                        expression: "'required'",
                        modifiers: { disable: true }
                      }
                    ],
                    attrs: {
                      name: "paidAt",
                      value: _vm.local.paymentDate,
                      type: "date",
                      "float-label": _vm.$t("expense_paid_at"),
                      "data-vv-as": _vm.$t("expense_paid_at"),
                      format: _vm.$t("date_format")
                    },
                    on: {
                      input: function(val) {
                        return _vm.update("paymentDate", val)
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "row" },
        [
          _c(
            "q-field",
            {
              staticClass: "col-8",
              attrs: {
                error: _vm.errors.has("totalNet"),
                "error-label": _vm.errors.first("totalNet")
              }
            },
            [
              _c("money-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate.disable",
                    value: "required|numeric",
                    expression: "'required|numeric'",
                    modifiers: { disable: true }
                  }
                ],
                attrs: {
                  name: "totalNet",
                  type: "number",
                  value: _vm.local.totalNet,
                  "float-label": _vm.$t("sum_net"),
                  "data-vv-as": _vm.$t("sum_net")
                },
                on: {
                  input: function(val) {
                    return _vm.update("totalNet", val)
                  }
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "row" },
        [
          _c(
            "q-field",
            {
              staticClass: "col-8",
              attrs: {
                error: _vm.errors.has("salesTaxAmount"),
                "error-label": _vm.errors.first("salesTaxAmount")
              }
            },
            [
              _c("money-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate.disable",
                    value: "required|numeric",
                    expression: "'required|numeric'",
                    modifiers: { disable: true }
                  }
                ],
                attrs: {
                  name: "salesTaxAmount",
                  type: "number",
                  value: _vm.local.salesTaxAmount,
                  "float-label": _vm.$t("sales_tax_amount"),
                  "data-vv-as": _vm.$t("sales_tax_amount")
                },
                on: {
                  input: function(val) {
                    return _vm.update("salesTaxAmount", val)
                  }
                }
              })
            ],
            1
          ),
          _c(
            "q-field",
            {
              staticClass: "col-4",
              attrs: {
                error: _vm.errors.has("salesTax"),
                "error-label": _vm.errors.first("salesTax")
              }
            },
            [
              _c("sales-tax-input", {
                attrs: {
                  value: _vm.local.salesTaxRate,
                  "float-label": _vm.$t("sales_tax_rate"),
                  "use-default": "",
                  required: ""
                },
                on: {
                  input: function(val) {
                    return _vm.update("salesTaxRate", val)
                  }
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "row" },
        [
          _c(
            "q-field",
            { staticClass: "col" },
            [
              _c("project-select", {
                attrs: {
                  value: _vm.local.projectId,
                  "float-label": _vm.$tc("project", 1),
                  "data-vv-as": _vm.$tc("project", 1),
                  clearable: ""
                },
                on: {
                  input: function(val) {
                    return _vm.update("projectId", val)
                  }
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }